import mittManager from "@/stores/mittManager";

class SocketIOManager {
    private socket: WebSocket | null = null;
    private connected = false;

    connect() {
        if (this.connected) return;

        // 解析token
        let userContextString = localStorage.getItem("zhihao-user");

        if (!userContextString) return;

        const userContext = JSON.parse(userContextString);

        if (!userContext.token) return;

        const url = new URL(import.meta.env.VITE_API_URL).host;

        this.socket = new WebSocket(`wss://${url}/ws/admin?token=${userContext.token}&app-type=1`);

        this.socket.addEventListener("open", () => {
            this.connected = true;

            this.sendPin();
        });

        this.socket.addEventListener("message", async event => {
            const data = JSON.parse(event.data);
            if (data?.type === 1) {
                // 刷新用户信息 - 会自动触发 路由拦截器中的 获取用户信息的接口
                window.location.reload();
            }
        });

        this.socket.addEventListener("close", () => {
            this.connected = false;
        });
    }

    sendPin() {
        const loop = () => {
            if (!this.connected) return;

            this.sendMessage({ heartBeat: "HEARTBEAT" });
            setTimeout(loop, 5000);
        };

        loop();
    }

    /**
     * 断开连接
     */
    disconnect() {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
        this.connected = false;
    }

    /**
     *
     * @param event 事件名
     * @param data 事件数据
     * @example
     * // 发送订单更新通知
     * socketIOManager.sendMessage("order:update", {
     *     orderId: 123,
     *     status: "paid"
     * });
     */
    sendMessage(data: any) {
        if (!this.socket || !this.connected) {
            console.warn("Socket 未连接，消息发送失败:", data);
            return false;
        }

        try {
            this.socket.send(JSON.stringify(data));
            return true;
        } catch (err) {
            console.error("Socket 消息发送异常:", err);
            return false;
        }
    }
}

const socketIOManager = new SocketIOManager();

// 由 store/user 触发
mittManager.on("LOGIN:AFTER", () => {
    socketIOManager.connect();
});

// 由 store/user 触发
mittManager.on("LOGOUT:AFTER", () => {
    socketIOManager.disconnect();
});

// 改为由mitt 管理ws以后，一般不会直接调用connect和disconnect方法
export default socketIOManager;
